(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired7c6"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired7c6"] = parcelRequire;
}
parcelRequire.register("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = {};
function $0380ce8f1f064ccc$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$0380ce8f1f064ccc$var$mapping[keys[i]] = pairs[keys[i]];
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

var $1de17b504f8b415d$exports = {};

(parcelRequire("iE7OH")).register(JSON.parse('{"jXFiS":"index.af8d93ba.js","f7gxa":"image1.a2f76ef8.png","h7xr9":"image1_2x.38f37bee.png","j5410":"image2.32168d70.png","cqMZH":"image2_2x.06900880.png","5EOPU":"image3.237e22ae.png","b3xSH":"image3_2x.032ee678.png","bxQXn":"image4.9b5889b4.png","7fOH2":"image4_2x.086ec6e2.png","bVtxb":"image5.4459924d.png","gNgmT":"image5_2x.cba46041.png","5xjT1":"image6.6990d88b.png","gKGw8":"image6_2x.2e43d496.png","1lVbT":"image7.181cb1fa.png","aYuzo":"image7_2x.51cb4288.png","lA8cL":"image8.88cae6e7.png","3XAoT":"image8_2x.7c961cd5.png","49EBR":"image9.15050564.png","dgUnf":"image9_2x.23d680cd.png","ei4R3":"amazon1.875cac08.png","c8Zp5":"applebook1.09bf885c.png","jeqkq":"barnesnoble.84820a41.png","2kw6b":"amazon@1x.100eb040.png","5iIId":"amazon@2x.fdf8ae2a.png","1WDfw":"applebook@1x.58f7dd67.png","dD20i":"applebook@2x.1c1863b9.png","E6g71":"barnesnoble@1x.e62c1f9d.png","96m6w":"barnesnoble@2x.84820a41.png"}'));

})();
//# sourceMappingURL=index.e16b030e.js.map
